import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full flex flex-nowrap whitespace-nowrap" }
const _hoisted_2 = { class: "ml-auto pl-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.labels.lineItemQuantity) + " ", 1),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$dictionary.format(_ctx.labels.lineItemQuantityPostFix, [_ctx.quantity])), 1)
  ]))
}